export default __webpack_public_path__ + "static/media/dealerportal-products.91fe7e84.PNG";